import { useTranslations } from 'languages';
import { SearchForTagLayout } from 'modules/pages/searchForTag';
import { useRouter } from 'next/router';
import { FC } from 'react';
import { SearchForTagPropsType } from 'types/pages/SearchForTag';
import { useGetCurrentCapitalizeTitle } from 'utils/hooks/useGetCurrentCapitalizeTitle';
import { siteText } from '../../siteText';

export const SearchForTag: FC<SearchForTagPropsType> = ({ tagData }) => {
  const t = useTranslations();

  const { locale = '' } = useRouter();

  const {
    title_ru = '',
    title_uk = '',
    title_en = '',
    slug_en = '',
    slug_ru = '',
    slug_uk = '',
  } = { ...tagData[0].seo };

  const tagForH1Title = useGetCurrentCapitalizeTitle({
    title_ru: title_ru || '',
    title_uk: title_uk || '',
    title_en: title_en || '',
  });

  const metaForSearchForTag = {
    title: t('metaCosmetology.title', { tag: tagForH1Title }),
    description: t('metaCosmetology.description', { tag: tagForH1Title }),
    keywords: t('metaCosmetology.keyWord'),
    slugs: {
      slug_uk: slug_uk ? `tag/${slug_uk}` : '',
      slug_ru: slug_ru ? `tag/${slug_ru}` : '',
      slug_en: slug_en ? `tag/${slug_en}` : '',
    },
  };

  return (
    <SearchForTagLayout
      siteText={siteText}
      metaForSearchTag={metaForSearchForTag}
      tagData={tagData}
    />
  );
};
export default SearchForTag;
